import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 95px; 
      height: 55px;
    }`
  }
`

const MultiTabWidgetIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="135" height="75" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 135 75">
      <g id="graph_multi_widget" transform="translate(-1204 -41)">
        <g id="Rectangle_3310" data-name="Rectangle 3310" transform="translate(1204 41)" fill="#fff" stroke="currentColor" strokeWidth="3">
          <rect width="135" height="75" rx="5" stroke="none"/>
          <rect x="1.5" y="1.5" width="132" height="72" rx="3.5" fill="none"/>
        </g>
        <line id="Ligne_510" data-name="Ligne 510" x2="48.754" transform="translate(1215.746 73)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <text id="TAB1" transform="translate(1239 66)" fill="currentColor" fontSize="15" fontFamily="Roboto-Bold, Roboto" fontWeight="700"><tspan x="-18.336" y="0">TAB1</tspan></text>
        <text id="TAB2" transform="translate(1299 66)" fill="#787878" fontSize="15" fontFamily="Roboto-Bold, Roboto" fontWeight="700" opacity="0.5"><tspan x="-18.336" y="0">TAB2</tspan></text>
      </g>
    </SVG>
  </IconContainer>
)

export default MultiTabWidgetIcon